module.exports = __webpack_public_path__ + "static/media/hoffson_wireframe.f83e88a2.jpg";